import React, { useState, useEffect } from 'react';
import axios from 'axios';
import { useNavigate } from 'react-router-dom';
import '../Styles/LoginForm.css'
import api from '../../Api/Config'

const LoginForm = ({ isModalOpen, closeModal, isLoginDefault = true, setUser, redirectPath }) => {
  const [isLogin, setIsLogin] = useState(true);
  const [isForgotPassword, setIsForgotPassword] = useState(false);
  const [isOtpVerification, setIsOtpVerification] = useState(false);
  const navigate = useNavigate()
  const [phoneNumber, setPhoneNumber] = useState('');
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [name, setName] = useState('');
  const [message, setMessage] = useState('');
  const [otp, setOtp] = useState('');
  const [tempUserId, setTempUserId] = useState('');
  const [resendTimer, setResendTimer] = useState(0);

  useEffect(() => {
    setIsLogin(isLoginDefault);
    setIsForgotPassword(false);
    setIsOtpVerification(false);
    setMessage('');
    setOtp('');
    setTempUserId('');
    setResendTimer(0);
  }, [isModalOpen, isLoginDefault]);

  // Resend timer countdown
  useEffect(() => {
    let interval = null;
    if (resendTimer > 0) {
      interval = setInterval(() => {
        setResendTimer(resendTimer - 1);
      }, 1000);
    } else if (resendTimer === 0) {
      clearInterval(interval);
    }
    return () => clearInterval(interval);
  }, [resendTimer]);

  const switchToRegister = () => {
    setIsLogin(false);
    setIsForgotPassword(false);
    setIsOtpVerification(false);
  };

  const switchToLogin = () => {
    setIsLogin(true);
    setIsForgotPassword(false);
    setIsOtpVerification(false);
  };

  const handleResendOtp = async () => {
    if (resendTimer > 0) return;

    try {
      setMessage('');
      const res = await axios.post('https://api-takeawaybackend.onrender.com/api/auth/resend-otp', {
        tempUserId,
      });
      setMessage(res.data.message);
      setResendTimer(60); // 60 seconds cooldown
    } catch (err) {
      setMessage(err?.response?.data?.message || 'Failed to resend OTP.');
    }
  };

  const handleOtpSubmit = async (e) => {
    e.preventDefault();
    setMessage('');

    try {
      const res = await axios.post('https://api-takeawaybackend.onrender.com/api/auth/verify-otp', {
        tempUserId,
        otp,
      });

      // Account created successfully
      const loggedInUser = res.data.user;
      setUser(loggedInUser);

      // Store token
      localStorage.setItem('token', res.data.token);
      localStorage.setItem('user', JSON.stringify(res.data.user));

      setMessage(res.data.message);
      setTimeout(() => {
        closeModal();
        if (loggedInUser.role === 'admin') {
          navigate('/');
        } else {
          navigate('/');
        }
      }, 1500);

    } catch (err) {
      setMessage(err?.response?.data?.message || 'Invalid OTP. Please try again.');
    }
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setMessage('');

    try {
      if (isForgotPassword) {
        // Forgot Password API
        const res = await api.post('/auth/forgot-password', {
          email,
        });
        setMessage(res.data.message);
      }
      else if (isLogin) {
        // Login API
        const res = await api.post('/auth/login', {
          email,
          password,
        });

        const loggedInUser = res.data.user;
        setUser(loggedInUser);

        // Navigation logic
        if (redirectPath === '/cart') {
          navigate('/cart');
        } else {
          navigate('/');
        }

        // Store token and user data
        localStorage.setItem('token', res.data.token);
        localStorage.setItem('user', JSON.stringify(res.data.user));
        window.dispatchEvent(new Event('userLoggedIn'));

        closeModal(); // Close modal on success
      }
      else {
        // Register API - now sends OTP
        const res = await api.post('/auth/register', {
          name,
          email,
          password,
          phone: phoneNumber,
        });

        // Store temporary user ID and switch to OTP verification
        setTempUserId(res.data.tempUserId);
        setMessage(res.data.message);
        setIsOtpVerification(true);
        setResendTimer(60); // Start 60 second timer for resend
      }
    } catch (err) {
      // Enhanced error handling
      if (err.response) {
        // Backend returned an error response
        setMessage(err.response.data.message || 'Something went wrong.');
      } else if (err.request) {
        // Network error - backend might be down
        setMessage('Unable to connect to server. Please check your internet connection.');
      } else {
        // Other error
        setMessage('Something went wrong. Please try again.');
      }

      console.error('Request error:', err);
    }
  };

  if (!isModalOpen) return null;

  return (
    <div style={{ fontFamily: 'Arial, sans-serif' }}>
      <div className={`modal-overlay ${isModalOpen ? 'active' : ''}`} onClick={closeModal}>
        <div className="modal" onClick={(e) => e.stopPropagation()}>
          <div className="modal-header">
            <h2 className="modal-title">
              {isOtpVerification
                ? 'Verify Your Email'
                : isForgotPassword
                  ? 'Reset Password'
                  : isLogin
                    ? 'Login'
                    : 'Sign Up'}
            </h2>
            <button className="close-button" onClick={closeModal}>×</button>
          </div>

          <div className="modal-body">
            {isOtpVerification ? (
              // OTP Verification Form
              <div>
                <div style={{ textAlign: 'center', marginBottom: '20px' }}>
                  <p style={{ color: '#666', fontSize: '0.9rem' }}>
                    We've sent a verification code to<br />
                    <strong>{email}</strong>
                  </p>
                </div>

                <form onSubmit={handleOtpSubmit} className="form-content">
                  <div className="form-group">
                    <input
                      type="text"
                      placeholder="Enter 6-digit OTP"
                      value={otp}
                      onChange={(e) => setOtp(e.target.value.replace(/\D/g, '').slice(0, 6))}
                      className="input-field"
                      style={{
                        textAlign: 'center',
                        fontSize: '1.2rem',
                        letterSpacing: '0.2rem',
                        fontWeight: 'bold'
                      }}
                      maxLength={6}
                      required
                    />
                  </div>

                  <button type="submit" className="primary-button">
                    Verify & Create Account
                  </button>
                </form>

                <div style={{ textAlign: 'center', marginTop: '15px' }}>
                  <p style={{ fontSize: '0.9rem', color: '#666' }}>
                    Didn't receive the code?{' '}
                    <span
                      className={`switch-link ${resendTimer > 0 ? 'disabled' : ''}`}
                      onClick={handleResendOtp}
                      style={{
                        cursor: resendTimer > 0 ? 'not-allowed' : 'pointer',
                        opacity: resendTimer > 0 ? 0.6 : 1
                      }}
                    >
                      {resendTimer > 0 ? `Resend in ${resendTimer}s` : 'Resend OTP'}
                    </span>
                  </p>
                </div>

                <div className="switch-text">
                  <span className="switch-link" onClick={() => {
                    setIsOtpVerification(false);
                    setIsLogin(false);
                  }}>
                    ← Back to Registration
                  </span>
                </div>
              </div>
            ) : (
              // Regular Login/Register/Forgot Password Form
              <form onSubmit={handleSubmit} className="form-content">
                {!isLogin && !isForgotPassword && (
                  <div className="form-group">
                    <input
                      type="text"
                      placeholder="Full Name"
                      value={name}
                      onChange={(e) => setName(e.target.value)}
                      className="input-field"
                      required
                    />
                  </div>
                )}

                <div className="form-group">
                  <input
                    type="email"
                    placeholder="Email"
                    value={email}
                    onChange={(e) => setEmail(e.target.value)}
                    className="input-field"
                    required
                  />
                </div>

                {!isLogin && !isForgotPassword && (
                  <div className="form-group">
                    <input
                      type="tel"
                      placeholder="Phone Number"
                      value={phoneNumber}
                      onChange={(e) => setPhoneNumber(e.target.value)}
                      className="phone-input"
                      required
                    />
                  </div>
                )}

                {!isForgotPassword && (
                  <div className="form-group">
                    <input
                      type="password"
                      placeholder="Password"
                      value={password}
                      onChange={(e) => setPassword(e.target.value)}
                      className="input-field"
                      required
                    />
                  </div>
                )}

                {isLogin && !isForgotPassword && (
                  <div className="form-group" style={{ textAlign: 'right' }}>
                    <span
                      className="switch-link"
                      onClick={() => setIsForgotPassword(true)}
                      style={{ fontSize: '0.9rem', cursor: 'pointer' }}
                    >
                      Forgot Password?
                    </span>
                  </div>
                )}

                <button type="submit" className="primary-button">
                  {isForgotPassword
                    ? 'Send Reset Link'
                    : isLogin
                      ? 'Login'
                      : 'Create Account'}
                </button>
              </form>
            )}

            {message && (
              <p style={{
                marginTop: '10px',
                color: message.includes('error') || message.includes('Invalid') || message.includes('Failed') ? 'red' : 'green',
                textAlign: 'center'
              }}>
                {message}
              </p>
            )}

            {!isOtpVerification && (
              <div className="switch-text">
                {isForgotPassword ? (
                  <span className="switch-link" onClick={() => setIsForgotPassword(false)}>
                    ← Back to Login
                  </span>
                ) : (
                  <>
                    {isLogin ? 'New to GrabGrub?' : 'Already have an account?'}{' '}
                    <span className="switch-link" onClick={isLogin ? switchToRegister : switchToLogin}>
                      {isLogin ? 'Create account' : 'Log in'}
                    </span>
                  </>
                )}
              </div>
            )}
          </div>
        </div>
      </div>
    </div>
  );
};

export default LoginForm;